"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.attributeDescriptorName = exports.attributeDescriptorLocalId = exports.resultHeaderName = exports.isResultTotalHeader = exports.isResultMeasureHeader = exports.isResultAttributeHeader = exports.isTotalDescriptor = exports.isMeasureDescriptor = exports.isMeasureGroupDescriptor = exports.isAttributeDescriptor = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
/* eslint-disable @typescript-eslint/no-empty-interface, import/namespace */
var m = tslib_1.__importStar(require("@gooddata/sdk-model"));
//
// Type guards
//
/**
 * Type-guard testing whether the provided object is an instance of {@link IAttributeDescriptor}.
 *
 * @deprecated Use {@link @gooddata/sdk-model#isAttributeDescriptor}
 * @public
 */
exports.isAttributeDescriptor = m.isAttributeDescriptor;
/**
 * Type-guard testing whether the provided object is an instance of {@link IMeasureGroupDescriptor}.
 *
 * @deprecated Use {@link @gooddata/sdk-model#isMeasureGroupDescriptor}
 * @public
 */
exports.isMeasureGroupDescriptor = m.isMeasureGroupDescriptor;
/**
 * Type-guard testing whether the provided object is an instance of {@link IMeasureDescriptor}.
 *
 * @deprecated Use {@link @gooddata/sdk-model#isMeasureDescriptor}
 * @public
 */
exports.isMeasureDescriptor = m.isMeasureDescriptor;
/**
 * Type-guard testing whether the provided object is an instance of {@link ITotalDescriptor}.
 *
 * @deprecated Use {@link @gooddata/sdk-model#isTotalDescriptor}
 * @public
 */
exports.isTotalDescriptor = m.isTotalDescriptor;
/**
 * Type-guard testing whether the provided object is an instance of {@link IResultAttributeHeader}.
 *
 * @deprecated Use {@link @gooddata/sdk-model#isResultAttributeHeader}
 * @public
 */
exports.isResultAttributeHeader = m.isResultAttributeHeader;
/**
 * Type-guard testing whether the provided object is an instance of {@link IResultMeasureHeader}.
 *
 * @deprecated Use {@link @gooddata/sdk-model#isResultMeasureHeader}
 * @public
 */
exports.isResultMeasureHeader = m.isResultMeasureHeader;
/**
 * Type-guard testing whether the provided object is an instance of {@link IResultTotalHeader}.
 *
 * @deprecated Use {@link @gooddata/sdk-model#isResultTotalHeader}
 * @public
 */
exports.isResultTotalHeader = m.isResultTotalHeader;
//
//
//
/**
 * Returns item name contained within a result header.
 *
 * @param header - header of any type
 * @deprecated Use {@link @gooddata/sdk-model#resultHeaderName}
 * @public
 */
exports.resultHeaderName = m.resultHeaderName;
/**
 * Returns local identifier of attribute described in the provided attribute descriptor.
 *
 * @param descriptor - attribute descriptor, must be specified
 * @deprecated Use {@link @gooddata/sdk-model#attributeDescriptorLocalId}
 * @public
 */
exports.attributeDescriptorLocalId = m.attributeDescriptorLocalId;
/**
 * Returns name of attribute described in the provided attribute descriptor.
 *
 * @param descriptor - attribute descriptor, must be specified
 * @deprecated Use {@link @gooddata/sdk-model#attributeDescriptorName}
 * @public
 */
exports.attributeDescriptorName = m.attributeDescriptorName;
//# sourceMappingURL=results.js.map